import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[appControlE]',
    standalone: false
})
export class ControlEDirective {
  @Output() controlEPressed = new EventEmitter<KeyboardEvent>();

  @HostListener('document:keydown.control.e', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.preventDefault(); // Prevent the default action
    this.controlEPressed.emit(event);
    }
}